// Garde-fou de route : réserve un écran aux administrateurs d'un partenaire.
//
// Masquer l'entrée du menu (`hideInPartnerMember` dans components/MenuItems/links.tsx)
// ne ferme rien : l'URL tapée à la main reste accessible. Ce composant bloque
// réellement l'accès côté client ; le backend applique la même règle de son côté.
//
// Prudence volontaire : on ne redirige QUE si l'on sait positivement que
// l'utilisateur est un collaborateur "member" d'un partenaire. Tout autre cas
// passe, pour ne pas éjecter un profil légitime sur une donnée incomplète.
// (Le UserContextProvider n'affiche ses enfants qu'une fois le profil chargé,
// il n'y a donc pas de fenêtre où `user` serait encore nul ici.)
import React, { FC, ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";

import { UserContext } from "features/account";

type PartnerAdminRouteProps = {
    children: ReactNode;
    redirectTo?: string;
};

const PartnerAdminRoute: FC<PartnerAdminRouteProps> = ({
    children,
    redirectTo = "/professionnels/dashboard",
}) => {
    const { user, userType } = useContext(UserContext);

    const isPartner = userType === "partner" || userType === "professionnels";
    const isMember = user?.partnerRole === "member";

    if (isPartner && isMember) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};

export default PartnerAdminRoute;
